/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/14/20
 * Copyright All Rights Reserved
 */
import React from 'react';
import { Col, Row } from 'reactstrap';
import CreateOrganizationForm from './CreateOrganizationForm';

const CreatOrganization = () => (
  <div>
    <Row>
      <Col md="12">
        <h1>Create Organization</h1>
      </Col>
    </Row>
    <Row>
      <Col md="12">
        <CreateOrganizationForm />
      </Col>
    </Row>
  </div>
);

export default CreatOrganization;



// WEBPACK FOOTER //
// ./js/components/pages/Admin/sections/Organizations/CreateOrganization/index.jsx